import { render, staticRenderFns } from "./composeIcon.vue?vue&type=template&id=3ba79740&scoped=true"
import script from "./composeIcon.vue?vue&type=script&lang=js"
export * from "./composeIcon.vue?vue&type=script&lang=js"
import style0 from "./composeIcon.vue?vue&type=style&index=0&id=3ba79740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_df42b2ab6613268ca01723f0a843be52/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba79740",
  null
  
)

export default component.exports